import { DAY_IN_SECONDS, HOUR_IN_SECONDS } from "./times";

/* 

  NextJs Revalidation 

*/

// Layouts
export const REVALIDATE_GLOBAL_LAYOUT_SECONDS = HOUR_IN_SECONDS * 2;

// Homepage
export const REVALIDATE_HOMEPAGE_SECONDS = HOUR_IN_SECONDS * 3;
export const REVALIDATE_FOOTER_SECONDS = HOUR_IN_SECONDS * 3;

// Product details page
export const REVALIDATE_PDP_SECONDS = DAY_IN_SECONDS;

// Standard pages (dynamic), content from ContentHubOne
export const REVALIDATE_STANDARDPAGE_SECONDS = DAY_IN_SECONDS * 3;
